<template>
  <div class="body-pieces">
    <template v-if="isWoollen === true">
      <div class="body-pieces__title">颜色/尺码/数量</div>
      <table class="productDemandsListHead-table">
        <tr class="productDemandsListHead-table__tr" v-if="info.productDemandsListHead.length > 0">
          <th
            v-for="(item, $index) in info.productDemandsListHead"
            :key="`productDemandsListHead-${$index}`"
          >{{item}}</th>
        </tr>
        <tr
          class="productDemandsListHead-table__tr"
          v-for="(item, $index) in info.productDemandsListCtx"
          :key="`productDemandsListCtx-${$index}`"
        >
          <td v-for="(inner, $inner_index) in item" :key="`inner-${$inner_index}`">{{inner}}</td>
        </tr>
      </table>
    </template>
    <template v-else>
      <div class="body-pieces__title">中码纸样片数</div>
      <div class="body-pieces__list">
        <div
          :key="`body-pieces__item-${$index}`"
          v-for="(item, $index) in info.pieceList"
          class="body-pieces__item"
        >
          <div class="body-pieces__list__title">{{item.pieceName}}</div>
          <div class="body-pieces__list__value">{{item.pieceNum}}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { formatImgUrl } from "src/filter/modules/img";

export default {
  name: "print-pieces",
  filters: {
    formatImgUrl,
    formatCodeList(array, keys) {
      return array
        .reduce((pre, next) => {
          const index = keys.findIndex(inner => inner.colorCode == next);
          if (index > -1) pre.push(keys[index].colorName);
          return pre;
        }, [])
        .join(",");
    },
    filterSizeName(obj) {
      const { sizeCode, sizeName } = obj;
      const str = sizeName.match(/[a-zA-Z]+/);
      if (sizeCode == "pieceSize" || sizeCode == "codeSize") return sizeName;
      if (!str) return sizeName;
      return str[0];
    },
    formatString(str) {
      if (!str) return "";
      return str.replace(/\s*/g, "");
    }
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isWoollen: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
@import "src/sass/modules/mixin";
$_normal_font: 4mm;
$_title_font: 5mm;
$box_width: 190mm;
$box_height: 277mm;
$_black: #333;
.default_text_over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  overflow: hidden;
}
.default_border {
  border-top: 1px solid $_black;
  border-left: 1px solid $_black;
}
.default_title {
  height: 6mm;
  text-align: center;
}
.default_table {
  width: 100%;
  td {
    border-collapse: collapse;
  }
  td,
  th {
    border: 1px solid $_black;
    border: 1px solid $_black;
  }
}
// 中码纸样片数
.body-pieces {
  border-right: 1px solid $_black;
  .body-pieces__title {
    @extend .default_title;
    @extend .default_border;
  }
  .body-pieces__list {
    @include flex_center(flex-start, flex-start);
    flex-wrap: wrap;
    .body-pieces__item {
      width: calc(100% / 6);
      height: calc(28mm / 2);
      text-align: center;
      @extend .default_border;
      @include grid_template(100%, 50% 50%);
    }
    .body-pieces__list__value {
      border-top: 1px solid $_black;
    }
  }
}

//颜色/尺码/数量
  .productDemandsListHead-table {
    @extend .default_table;
    .productDemandsListHead-table__tr {
      height: 6.9mm;
    }
    .productDemandsListHead-table__tr {
      height: 6.9mm;
    }
  }
</style>
